export default __webpack_public_path__ + "static/media/336-tile.ba3bc9f5.svg";